import styled from 'styled-components';

export const Container = styled.div`
  background-color: #677ddb;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  box-sizing:border-box;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const FormContainer = styled.div`
  background-color: #fff;
  border-radius: 1rem;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  padding: 3rem;
  max-width: 66rem;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    max-width: 100%;    
    box-shadow: none;
    padding: 1rem;
  }
`;

export const FormHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 3rem;

  @media (max-width: 768px) {
    margin-bottom: 2rem;
  }
`;

export const FormLogo = styled.img`
  height: 100px;
  margin-right: 1rem;

  @media (max-width: 768px) {
    height: 80px;
    margin-right: 0.5rem;
  }
`;

export const FormDivider = styled.div`
  height: 1px;
  margin-bottom: 3rem;
  background-image: linear-gradient(to right, #ccc 50%, transparent 0%);
  background-size: 15px 1px;
  background-repeat: repeat-x;

  @media (max-width: 768px) {
    margin-bottom: 2rem;
  }
`;

export const FormName = styled.h2`
  font-size: 1.7rem;
  font-weight: 600;
  margin-bottom: 1rem;
  text-align: center;  

  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
`;

export const FormButton = styled.button`
  display:block;
  background-color: #e5ebff;
  color: #627cd8;  
  border-radius: 5px;
  border: none;
  font-size: 1.13rem;
  font-weight: 550;
  margin-right: 1.5rem;
  transition: all 0.3s ease-in-out;
  cursor:pointer;
  min-width:230px;
  padding:17px 40px;
  border:2px solid transparent;
  box-sizing:border-box;  

  a{
    text-decoration:none !important;
    width:100%;
    height:100%;
    padding:17px 40px;
    box-sizing: border-box;
    &:hover{
      text-decoration:none !important;
    }
  }
  &:hover {
    background-color: #6f84dd;
    color: #fff;    
  }
  &.border_btn{
    background-color:transparent;
    border:1px solid #627cd8;

    &:hover{
      background-color: #6f84dd;
      color: #fff;
    }
  }

  &.lg_btn{
    margin:0 auto;
    background-color:#fff;  
    color:#627CD8;  
    box-shadow: 0px 1px 14px rgba(98, 124, 216, 0.29);
    border-radius: 8px;
    border:4px solid transparent;
    min-width:500px;    
    box-sizing:border-box;
    padding:0;
    a{
      display:inline-block;
      padding:25px 30px !important;
      box-sizing: border-box;
    }

    &:hover{
      background: #E5EBFF;
      border: 4px solid rgba(98, 124, 216, 0.52);            
      box-shadow: 0px 1px 14px rgba(98, 124, 216, 0.29);      
    }
    &:not(:first-child){
      margin-top:25px !important;
    }
    &:last-child{
      margin-bottom:50px !important;
    }
  }

  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 0.3rem 0.8rem;
    margin-right: 0.5rem;
    &.lg_btn{
      min-width:230px;
      a{
        padding:15px 25px !important;
      }
      &:last-child{
        margin-top:30px !important;
        margin-bottom:30px !important;
      }
    }    
  }
`;
export const FormCustomContainer = styled.div`
  width:90%;
  margin:0 auto;  

`;
export const FormFooter = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const FormDescription = styled.p`
  font-size: 1.1rem;
  margin-bottom: 3rem;
  text-align: center;
  font-weight:500;

  @media (max-width: 768px) {
    font-size: 0.9rem;
    margin-bottom: 2rem;
  }
`;

export const FormStepCard = styled.div`
  border: 1px solid #EEEEEE;
  border-radius: 0.5rem;
  padding: 1rem 3rem;
  padding-bottom: 5rem;
  margin-bottom: 3rem;
  width: 80%; /* Change the width of the form step card */
  margin: 0 auto; /* Center the form step card horizontally */

  /* Responsive styles */
  @media screen and (max-width: 900px) {

    padding: 1rem 1.8rem;
    box-sizing:border-box;
    width:90%;
    
    .gateway_sec .MuiGrid-container,
    .reference_sec .MuiGrid-container{
      grid-gap:0 24px;
    }
    .upload_sec .MuiGrid-container{
      grid-gap:15px 24px;
    }
    .gateway_sec .MuiGrid-grid-sm-6,
    .gateway_sec .MuiGrid-grid-xs-6,
    .reference_sec .MuiGrid-grid-sm-6,
    .reference_sec .MuiGrid-grid-xs-6,
    .upload_sec .MuiGrid-grid-xs-6,
    .upload_sec .MuiGrid-grid-sm-6{
      flex-basis:calc(50% - 12px);      
    }
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    box-sizing:border-box;    
    padding: 1rem 1.2rem;

    .gateway_sec .MuiOutlinedInput-input,
    .reference_sec .MuiOutlinedInput-input,
    .upload_sec .MuiOutlinedInput-input{
      height:12px;
      display:inline-flex;
      align-items:center;
      min-height:initial !important;
    }

    .gateway_sec .tblTop_title,
    .reference_sec .tblTop_title,
    .upload_sec .tblTop_title{
      margin-top:30px;
      line-height:1;
      font-size:18px;
    }
    .gateway_sec .tbl_title, 
    .reference_sec .tbl_title,
    .upload_sec .tbl_title{
      margin-top:40px !important;
      line-height:1;
      font-size:18px;
    }
    .upload_sec .res_block_upload {
      display:block !important;
    }
  }
  @media screen and (max-width: 575px) {    
    
    .gateway_sec .MuiGrid-container,
    .reference_sec .MuiGrid-container{
      grid-gap:0;
    }
    .gateway_sec .MuiGrid-grid-sm-6,
    .gateway_sec .MuiGrid-grid-xs-6,
    .reference_sec .MuiGrid-grid-sm-6,
    .reference_sec .MuiGrid-grid-xs-6,
    .upload_sec .MuiGrid-grid-sm-6,
    .upload_sec .MuiGrid-grid-xs-6{
      flex-basis:100%;      
    }    

    .gateway_sec .MuiOutlinedInput-input,
    .reference_sec .MuiOutlinedInput-input{
      height:8px;
    }   
  }
`;